export default {
  Placeholder: {
    src: new URL(
      "./Placeholder.png?as=png&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Placeholder.png?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./Placeholder.png?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./Placeholder.png?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./Placeholder.png?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./Placeholder.png?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./Placeholder.png?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Budding_Leggings: {
    src: new URL(
      "./buddingleggings.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./buddingleggings.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./buddingleggings.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./buddingleggings.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./buddingleggings.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./buddingleggings.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./buddingleggings.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Full_Bloom_Long_Shirt_Dress: {
    src: new URL(
      "./fullbloomlongshirtdress.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./fullbloomlongshirtdress.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./fullbloomlongshirtdress.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./fullbloomlongshirtdress.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./fullbloomlongshirtdress.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./fullbloomlongshirtdress.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./fullbloomlongshirtdress.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Old_Growth_Long_Shirt_Dress: {
    src: new URL(
      "./oldgrowthlongshirtdress.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./oldgrowthlongshirtdress.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./oldgrowthlongshirtdress.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./oldgrowthlongshirtdress.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./oldgrowthlongshirtdress.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./oldgrowthlongshirtdress.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./oldgrowthlongshirtdress.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Giant_Kelp_Poncho: {
    src: new URL(
      "./giantkelpponcho.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./giantkelpponcho.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./giantkelpponcho.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./KelpPoncho.png?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./giantkelpponcho.jpg?as=jpg&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./giantkelpponcho.jpg?as=jpg&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./giantkelpponcho.jpg?as=jpg&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Mycelium_Ribbed_Sweatpants: {
    src: new URL(
      "./myceliumsweatpantslight.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./myceliumsweatpantslight.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./myceliumsweatpantslight.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./myceliumsweatpantslight.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./myceliumsweatpantslight.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./myceliumsweatpantslight.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./myceliumsweatpantslight.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Bitcoin_Bloom_Bomber: {
    src: new URL(
      "./bitcoinbloombomber.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./bitcoinbloombomber.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./bitcoinbloombomber.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./bitcoinbloombomber.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./bitcoinbloombomber.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./bitcoinbloombomber.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./bitcoinbloombomber.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Abyss_Pintuck_Pants: {
    src: new URL(
      "./abysspintuckpants.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./abysspintuckpants.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./abysspintuckpants.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./abysspintuckpants.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./abysspintuckpants.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./abysspintuckpants.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./abysspintuckpants.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  "Soft_Coral_Crewneck_T-Shirt": {
    src: new URL(
      "./softcoralribbedcrewneck.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./softcoralribbedcrewneck.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./softcoralribbedcrewneck.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./softcoralribbedcrewneck.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./softcoralribbedcrewneck.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./softcoralribbedcrewneck.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./softcoralribbedcrewneck.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Mycelium_Ribbed_Sweatpants_Dark: {
    src: new URL(
      "./myceliumsweatpantsdark.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./myceliumsweatpantsdark.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./myceliumsweatpantsdark.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./myceliumsweatpantsdark.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./myceliumsweatpantsdark.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./myceliumsweatpantsdark.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./myceliumsweatpantsdark.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Perennial_Coverall: {
    src: new URL(
      "./perennialcoverall.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./perennialcoverall.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./perennialcoverall.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./perennialcoverall.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./perennialcoverall.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./perennialcoverall.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./perennialcoverall.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Mycelium_Ribbed_Mock_Neck_Sweatshirt: {
    src: new URL(
      "./myceliumribbedmockneck.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./myceliumribbedmockneck.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./myceliumribbedmockneck.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./myceliumribbedmockneck.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./myceliumribbedmockneck.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./myceliumribbedmockneck.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./myceliumribbedmockneck.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Infinite_Coral_Overshirt: {
    src: new URL(
      "./infinitecoralovershirt.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./infinitecoralovershirt.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./infinitecoralovershirt.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./infinitecoralovershirt.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./infinitecoralovershirt.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./infinitecoralovershirt.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./infinitecoralovershirt.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Dry_Earth_Chino_Pants: {
    src: new URL(
      "./dryearthchinopants.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./dryearthchinopants.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./dryearthchinopants.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./dryearthchinopants.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./dryearthchinopants.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./dryearthchinopants.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./dryearthchinopants.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Infinite_Coral_Chino_Pants: {
    src: new URL(
      "./infinitecoralchinopants.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./infinitecoralchinopants.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./infinitecoralchinopants.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./infinitecoralchinopants.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./infinitecoralchinopants.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./infinitecoralchinopants.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./infinitecoralchinopants.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Cryptotendril_Knit_Vest: {
    src: new URL(
      "./cryptotendrilknitvest.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./cryptotendrilknitvest.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./cryptotendrilknitvest.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./cryptotendrilknitvest.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./cryptotendrilknitvest.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./cryptotendrilknitvest.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./cryptotendrilknitvest.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Kombu_Cropped_Front_Sweatshirt: {
    src: new URL(
      "./kombucroppedfrontsweatshirt.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./kombucroppedfrontsweatshirt.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./kombucroppedfrontsweatshirt.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./kombucroppedfrontsweatshirt.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./kombucroppedfrontsweatshirt.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./kombucroppedfrontsweatshirt.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./kombucroppedfrontsweatshirt.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Kombu_Sweatpants: {
    src: new URL(
      "./kombusweatpants.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./kombusweatpants.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./kombusweatpants.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./kombusweatpants.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./kombusweatpants.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./kombusweatpants.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./kombusweatpants.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
  Algae_Bloom_Turtleneck: {
    src: new URL(
      "./algaebloomturtleneck.jpg?as=jpg&width=600",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./algaebloomturtleneck.jpg?as=webp&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./algaebloomturtleneck.jpg?as=webp&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./algaebloomturtleneck.jpg?as=webp&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
      jpg: `${
        new URL(
          "./algaebloomturtleneck.jpg?as=png&width=800?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 800w,${
        new URL(
          "./algaebloomturtleneck.jpg?as=png&width=600?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 600w,${
        new URL(
          "./algaebloomturtleneck.jpg?as=png&width=400?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 400w,`,
    },
  },
};
